import { useEffect, useMemo, useState } from "react";

export function useMediaQuery(query: string) {
  const mql = useMemo(() => window.matchMedia(query), [query]);
  const [matches, setMatches] = useState(() => mql.matches);

  useEffect(() => {
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [mql]);

  return matches;
}

